import { render, staticRenderFns } from "./Header-Wx.vue?vue&type=template&id=8ece4638&scoped=true"
import script from "./Header-Wx.vue?vue&type=script&lang=js"
export * from "./Header-Wx.vue?vue&type=script&lang=js"
import style0 from "./Header-Wx.vue?vue&type=style&index=0&id=8ece4638&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ece4638",
  null
  
)

export default component.exports